module.exports = __webpack_public_path__ + "cb8b574d166ca9f1d00e43a82fd8439b.pdf";